<template>
  <span>
    <a href="#" @click="show = true"  v-b-tooltip.hover> 
      <span v-if="creator">     
        <MessageStatus v-if="info.status" :status="info.status"></MessageStatus>
        <span v-if="!info.status" :title='showStatus'>
          <i v-if="getStatus == 0" class="fal fa-envelope"></i>
          <i v-if="getStatus == 1" class="fal fa-envelope-open"></i>
          <i v-if="getStatus == 2" class="fal fa-ban"></i>
          <i v-if="getStatus == 3" class="fal fa-comment"></i>
          <i v-if="getStatus == 10" class="fal fa-exclamation-circle red"></i>
        </span>
      </span>
      {{info.email}}<span v-if="!islast">;&nbsp;&nbsp;</span>
    </a>
    <b-sidebar
      id="message-securelink"
      v-model="show"
      right
      no-slide
      shadow
      backdrop
    >      
     <SecureLinkInformation_4_2 :functionbox_uuid="functionbox_uuid" :response="response" :index="index" :item="info"></SecureLinkInformation_4_2>

    </b-sidebar>

  </span>
</template>
<script>
import MessageStatus from "@/components/View/MessageStatus";
import SecureLinkInformation_4_2 from "@/components/View/SecureLinkInformation_4_2";
export default {
  components: { SecureLinkInformation_4_2, MessageStatus },
  props: ["response","item","index","islast","creator","status","functionbox_uuid"],
  data() {
    return {
      show: false,
      info: this.item,
      showDialog: false,
      showResponse: false,
      viewed: false,
      viewed_date: ''
    };
  },
  methods: {
    viewResponse: function() {
      this.showResponse = true;
    },
    onShow: function() {
      this.$root.$emit('bv::hide::popover')
    },
    onClose: function() {
      this.showDialog = false;
    }
  },
  computed: {    
    getStatus() {
      if(this.info.response_message_uuid != "")
      {
        return 3;
      }
      if(this.info.recalled == 1)
      {
        return 2;
      }
      if(this.info.viewed == 1)
      {
        return 1;
      }
      if(this.info.sent != undefined)
      {
        if (this.info.sent == 0) {
          return 10;
        }
      }
      return 0;
    },
    showStatus() {
      if(this.info.response_message_uuid != "")
      {
        return this.$t("RESPONSED");
      }
      if(this.info.recalled == 1)
      {
        return this.$t("RECALLED");
      }
      if(this.info.viewed == 1)
      {
        return this.$t("VIEWED");
      }
      if(this.info.sent != undefined)
      {
        if (this.info.sent == 0) {
          return this.$t("NOT_SENT");
        }
      }
      return this.$t("NOT_VIEWED");
    }
  }
};
</script>
<style>
</style>